<template>
    <div id="comment">
      <van-nav-bar :border="false" title="发表评论" left-arrow @click-left="$router.go(-1);"/>
      <!-- <div class="comprehensiveBox">
          <span class="comprehensiveTitle">综合评价</span>
          <van-rate v-model="commentValue" readonly />
      </div> -->
      <div class="commentBody" v-for="(value,index) in commentDetail.details" :key="index">
          <div class="commentBodyHead">
              <div class="commentBodyHeadImg">
                  <img :src="baseUrl.imgUrl+value.orderDetailsProductImg.split(',')[0]" alt="">
              </div>
              <div class="commentBodyHeadP">
                    <p>{{value.orderDetailsProductName}}</p>
                    <van-rate v-model="value.orderEvaluateEvaLevel" />
              </div>
          </div>
          <van-field :border="false" v-model="value.orderEvaluateContent" rows="2" autosize type="textarea" maxlength="200" placeholder="商品满足您的期待吗？说说你的使用心得吧" show-word-limit />
          <van-uploader @delete="((val,detail)=>{onDelete(val,detail,index)})" :max-count="3" v-model="value.orderEvaluationImg1" :accept="'image/*'" :after-read="((val)=>{afterRead(val, index)})" />
      </div>
      <van-button class="submitBtn" color="#ED6549" @click="submitFn">提交评价</van-button>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import baseUrl from '@/config/baseUrl';
import axios from 'axios';
export default {
    name: 'Comment',
    data() {
        return {
            commentValue:5,
            baseUrl
        };
    },
    computed: {
        ...mapState('comment', {
            commentDetail: 'commentDetail'
        })
    },
    methods: {
        ...mapActions('comment', {
            getCommentDetail: 'getCommentDetailAction'
        }),
        ...mapActions('comment', {
            commentSubmitAjax: 'commentSubmitAction'
        }),
        afterRead(file,index) {
            this.$toast.loading({
                duration: 0,
                message: '上传中...',
                forbidClick: true
            });
            let fd = new FormData(),
                fileReq = axios.create({ withCredentials: false });
            fd.append('file', file.file);
            fd.append('type', 9);
            fd.append('wattertext', '');
            fileReq({
                url: this.baseUrl.uploadImg,
                method: 'POST',
                data: fd
            }).then(res => {
                this.$toast.clear();
                if(res.data.success){
                    this.commentDetail.details[index].orderEvaluationImg.push(res.data.data.objname);
                }else{
                    this.commentDetail.details[index].orderEvaluationImg1.splice(this.commentDetail.details[index].orderEvaluationImg1.length-1,1);
                    this.$toast('上传失败，请重新上传');
                }
            }).catch(err => {
                this.$toast(err.data.error);
            });
        },
        onDelete(file,detail,index){
            this.commentDetail.details[index].orderEvaluationImg.splice(detail.index,1);
        },
        queryDetail(params){
            this.getCommentDetail(params).then((res) => {
                // console.log(res);
            }).catch((res) => {
                this.$toast(res.error);
            });
        },
        submitFn(){
            let listData = {};
            for(let i=0;i<this.commentDetail.details.length;i++){
                listData['list['+i+'].orderEvaluateEvaLevel'] = this.commentDetail.details[i].orderEvaluateEvaLevel;
                listData['list['+i+'].orderEvaluateContent'] = this.commentDetail.details[i].orderEvaluateContent;
                listData['list['+i+'].orderDetailsId'] = this.commentDetail.details[i].orderDetailsId;
                listData['list['+i+'].orderEvaluationImg'] = this.commentDetail.details[i].orderEvaluationImg.join(',');
                listData['list['+i+'].orderNumber'] = this.commentDetail.details[i].orderDetailsOrderNumber;
            }
            this.commentSubmitAjax(listData).then((res) => {
                this.$toast.success(res.msg);
                this.$router.go(-1);
            }).catch((res) => {
                this.$toast(res.error);
            });
        }
    },
    created() {
        this.queryDetail(this.$route.query.orderNumber);
    }
};
</script>
<style lang="scss">
    #comment{
      .van-nav-bar{
        .van-icon-arrow-left{
          font-size: 25px;
          color: #000000;
        }
        .van-nav-bar__title{
          font-size:18px;
          font-family:PingFang SC;
          font-weight:bold;
          color:rgba(0,0,0,1);
        }
      }
      .comprehensiveBox{
          padding: 5px 20px 15px;
          margin-bottom: 7px;
          background: #fff;
          .comprehensiveTitle{
                font-size:15px;
                font-family:PingFang SC;
                font-weight:bold;
                color:#161616;
                line-height:30px;
                margin-right: 15px;
          }
            .van-icon{
                font-size: 13.5px !important;
            }
      }
      .commentBody{
          margin-top: 10px;
          background: #fff;
          padding: 10px;
          .commentBodyHead{
              display: flex;
              padding-bottom:10px;
              border-bottom: 1px solid #ECECEC;
              .commentBodyHeadImg{
                  margin-right: 13px;
                  flex: 1;
                  img{
                      width: 45px;
                      height: 45px;
                  }
              }
              .commentBodyHeadP{
                  flex: 10;
                  min-width: 0;
                    p{
                        font-size:14px;
                        font-family:PingFang SC;
                        font-weight:500;
                        color:#333333;
                        line-height:24px;
                        white-space: nowrap;
                        text-overflow:ellipsis;
                        overflow:hidden;
                    }
                    .van-icon{
                        font-size: 15px !important;
                    }
              }
          }
      }
      .submitBtn{
          width:80%;
          margin: 15px 10%;
      }
    }
</style>
